import React, { useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function RefuseCancelRequestModal({
  cancelModal,
  request,
  fetchData,
}) {
  const { user } = useAuthContext();
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  //styled
  const handleConfirm = async () => {
    try {
      setIsLoading(true);

      const updatebooking = {
        id: request.id,
      };
      const updateBookingResponse = await axios.put(
        `${ApiConnectionString}/api/booking`,
        updatebooking,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (updateBookingResponse.status == 200) {
        setComplete(true);
      } else {
        //handle
      }
    } catch (error) {
      console.error("Error canceling booking:", error); // Handle any errors
      // Optionally, set an error state or display an error message to the user
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />

          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">
                Booking Cancelation Refused
              </p>
            </div>

            <p>The user's request to cancel their booking has been refused.</p>

            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => {
                  fetchData();
                  cancelModal();
                }}
              >
                close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">
                Refuse This Cancel Request
              </p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <table>
              <tbody>
                <tr>
                  <td className="red-text">
                    <strong>User:</strong>
                  </td>
                  <td>{request.viewAppUser.username}</td>
                </tr>
                <tr>
                  <td className="red-text">
                    <strong>Event:</strong>
                  </td>
                  <td>{request.viewEvent.name} at</td>
                </tr>
                <tr>
                  <td className="red-text">
                    <strong>Time:</strong>
                  </td>
                  <td>
                    {request.viewEvent.timeIn} - {request.viewEvent.timeOut}
                  </td>
                </tr>
                <tr>
                  <td className="red-text">
                    <strong>Date:</strong>
                  </td>
                  <td>{new Date(request.date).toLocaleDateString()}</td>
                </tr>
              </tbody>
            </table>

            <p>
              Are you sure that you wish to refuse this cancellation of the
              booking?
            </p>

            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleConfirm}>
                Confirm
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
